import { useEffect } from 'react';

import type { UseAddAvailableProductsModalEffectsProps } from '@app/pages/Warehouses/WarehouseOperations/components/ProductOperation/types';

export const useAddAvailableProductsModalEffects = ({
  checkedKeysHandler,
}: UseAddAvailableProductsModalEffectsProps) => {
  useEffect(() => {
    checkedKeysHandler();
  }, [checkedKeysHandler]);
};
